export function initialSidebarExpanded() {
  if (typeof window === "undefined") return true;
  return window.matchMedia("(min-width: 901px)").matches;
}
